export default {
    'games.codelish.com': {
        type: 'users',
        name: 'codelish'
    },
    'games.madden.nyc': {
        type: 'users',
        name: 'rexmadden'
    },
    'stephenkuzma.com': {
        type: 'users',
        name: 'siroinks'
    },
    'www.stephenkuzma.com': {
        type: 'users',
        name: 'siroinks'
    },
    'shelf.thewrattens.us': {
        type: 'users',
        name: 'misterdaku'
    }
}